var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "task-config-container",
      on: { "tab-click": _vm.handleTabChange },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { lazy: "", label: "任务列表", name: "taskList" } },
            [
              _c("taskList", {
                attrs: { refresh: _vm.refresh, activeTab: _vm.activeTab },
                on: {
                  postList: _vm.postList,
                  reviewList: _vm.reviewList,
                  handleEdit: _vm.handleEdit,
                  handleCopy: _vm.handleCopy,
                  addAct: _vm.addAct,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { lazy: "", label: "帖子列表", name: "postList" } },
            [
              _c("postList", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
                on: { detailPost: _vm.showPostDetail },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "postDetail"
            ? _c(
                "el-tab-pane",
                { attrs: { lazy: "", label: "帖子详情", name: "postDetail" } },
                [
                  _c("postDetail", {
                    attrs: {
                      activeTab: _vm.activeTab,
                      actId: Number(_vm.actId),
                      actTitle: _vm.actTitle,
                      post: _vm.selectedPost,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { lazy: "", label: "审核列表", name: "reviewList" } },
            [
              _c("reviewList", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { lazy: "", label: "种草官列表", name: "trendSetterList" },
            },
            [
              _c("trendSetterList", {
                attrs: { activeTab: _vm.activeTab, actTitle: _vm.actTitle },
                on: {
                  detailUserLog: _vm.detailUserLog,
                  RewardUserLog: _vm.RewardUserLog,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { lazy: "", label: "种草官任务记录", name: "taskLog" } },
            [
              _c("taskLog", {
                attrs: {
                  activeTab: _vm.activeTab,
                  userId: Number(_vm.userId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { lazy: "", label: "种草官任务设置", name: "trendSetter" },
            },
            [
              _c("trendSetter", {
                attrs: {
                  activeTab: _vm.activeTab,
                  actId: Number(_vm.actId),
                  actTitle: _vm.actTitle,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "taskAdd"
            ? _c(
                "el-tab-pane",
                { attrs: { lazy: "", label: "添加任务", name: "taskAdd" } },
                [
                  _c("taskAdd", {
                    attrs: {
                      activeTab: _vm.activeTab,
                      actId: String(_vm.actId),
                    },
                    on: { saved: _vm.saved },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { lazy: "", label: "黑名单列表", name: "blacklist" } },
            [_c("blacklist", { attrs: { activeTab: _vm.activeTab } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }